import React, { useContext } from 'react';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { IconProps } from 'shared/icons/iconProps';

export default function IconIcPass({
  extColor,
  isAutoscallable = true,
  sizeKey = '24x24',
  onClick,
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M11.7501 0C13.7765 6.07441e-05 15.7574 0.60796 17.4425 1.74707C19.1277 2.88623 20.4415 4.50575 21.2179 6.40039C21.9941 8.29491 22.1977 10.3797 21.8038 12.3916C21.4098 14.4035 20.4356 16.2525 19.004 17.7041L11.7501 25.0469L10.5695 23.8516L17.8175 16.5146C19.0183 15.2989 19.8359 13.7496 20.1671 12.0635C20.4983 10.3775 20.3287 8.63003 19.6788 7.04199C19.0288 5.4538 17.9279 4.09567 16.5157 3.14062C15.1035 2.18557 13.4427 1.67578 11.7443 1.67578C10.046 1.6758 8.38587 2.18576 6.97375 3.14062C5.56152 4.09568 4.46073 5.45374 3.81066 7.04199C3.16068 8.63009 2.99027 10.3774 3.3214 12.0635C3.65261 13.7496 4.47018 15.2989 5.67101 16.5146C5.83107 16.6758 5.92206 16.8945 5.92297 17.123C5.92009 17.3442 5.83043 17.5556 5.67492 17.7109C5.51952 17.866 5.31012 17.953 5.09191 17.9531C4.98147 17.9532 4.87176 17.9312 4.76965 17.8887C4.66741 17.8459 4.57352 17.7831 4.49523 17.7041C3.06372 16.2525 2.08943 14.4035 1.69543 12.3916C1.30149 10.3797 1.50609 8.29494 2.28234 6.40039C3.05861 4.50585 4.37172 2.88622 6.05676 1.74707C7.74191 0.607903 9.72367 0 11.7501 0ZM11.8868 3.82617C15.519 3.82636 18.4464 6.75452 18.4464 10.3867C18.4462 14.0188 15.5189 16.9461 11.8868 16.9463C8.25462 16.9463 5.32644 14.0189 5.32629 10.3867C5.32629 6.7544 8.25452 3.82617 11.8868 3.82617ZM11.8868 10.8506C10.4231 10.8506 9.12138 11.7179 8.47082 12.9648C9.33823 13.8322 10.5315 14.374 11.8868 14.374C13.242 14.3739 14.435 13.8322 15.3566 12.9648C14.706 11.718 13.4047 10.8507 11.8868 10.8506ZM11.8868 6.35059C10.8568 6.35059 9.98937 7.16377 9.98937 8.24805C9.98943 9.27806 10.8568 10.1455 11.8868 10.1455C12.9709 10.1453 13.7842 9.27795 13.7843 8.24805C13.7843 7.16389 12.9709 6.35077 11.8868 6.35059Z"
        fill="#7C28E3"
      />
    </svg>
  );
}
